import HorizonIcon from '../../../icons/horizon.svg';
import LitterIcon from '../../../icons/analyze/litterIcon.svg';
import BinsIcon from '../../../icons/analyze/binIcon.svg';
import HotSpotsIcon from '../../../icons/analyze/hotspotIcon.svg';
import CollectedIcon from '../../../icons/collected.svg';

export const PICTURE_LABELS = {
    SEGMENT_INTRO: 'SEGMENT_INTRO',
    LITTER: 'LITTER',
    BIN: 'BIN',
    BAGGAGE: 'BAGGAGE',
    HOTSPOT: 'HOTSPOT',
};

export const ICONS_LABELS = {
    SEGMENT_INTRO: HorizonIcon,
    LITTER: LitterIcon,
    BIN: BinsIcon,
    BAGGAGE: CollectedIcon,
    HOTSPOT: HotSpotsIcon,
};

export const SORTING_ORDER = {
    [PICTURE_LABELS.SEGMENT_INTRO]: 1,
    [PICTURE_LABELS.LITTER]: 2,
    [PICTURE_LABELS.BIN]: 3,
    [PICTURE_LABELS.HOTSPOT]: 4,
    [PICTURE_LABELS.BAGGAGE]: 5,
};

export const PICTURE_TYPE = [
    {
        key: null,
        label: 'All',
        id: null,
    },

    {
        key: PICTURE_LABELS.LITTER,
        label: 'Litter',
        id: 1,
    },
    {
        key: PICTURE_LABELS.BIN,
        label: 'Bins',
        id: 2,
    },
    {
        key: PICTURE_LABELS.HOTSPOT,
        label: 'Hotspots',
        id: 3,
    },
    {
        key: PICTURE_LABELS.BAGGAGE,
        label: 'Collected',
        id: 4,
    },
];

export function getClassificationByImageType(imageType) {
    switch (imageType) {
        case 'Horizon':
            return PICTURE_LABELS.SEGMENT_INTRO;
        case 'Bin':
            return PICTURE_LABELS.BIN;
        case 'Litter':
            return PICTURE_LABELS.LITTER;
        case 'Dump':
            return PICTURE_LABELS.HOTSPOT;
        case 'Baggage':
            return PICTURE_LABELS.BAGGAGE;
        default:
            return PICTURE_LABELS.LITTER;
    }
}
